import FormatService from '../../../../services/format-service'

export default {
    name: 'Price',
    props: {
        prices: Array
    },
    data() {
        return {
            
        }
    },
    filters: {
        euro(value) {
            return FormatService.euro(value)
        }
    }
}